export default __webpack_public_path__ + "static/media/Montserrat-Medium.693c527a.ttf";